import React, { useState, useRef, useEffect } from 'react';
import {
  Box,
  Typography,
  Chip,
  Grid,
  TextField,
  LinearProgress,
  Avatar,
  Button,
  Divider,
  IconButton,
  Paper,
  Menu,
  MenuItem,
  Tabs,
  Tab,
  TableContainer,
  Table,
  TableBody,
  TableRow, Modal,
  TableCell, Dialog, DialogContent, DialogTitle, DialogActions, Tooltip, Snackbar, Alert
} from '@mui/material';
import {
  TaskAlt,
  Business,
  Person as PersonIcon,
  Timeline as TimelineIcon,
  Description as DescriptionIcon,
  PlaylistAddCheck as PlaylistAddCheckIcon,
  Code,
  AssignmentInd,
  Add as AddIcon,
  Visibility as VisibilityIcon,
  AccessTime as AccessTimeIcon,
  AttachFile as AttachFileIcon,
  CheckCircle as CheckCircleIcon,
  Delete as DeleteIcon, StarHalf as StarHalfIcon,
  Edit as EditIcon, Star as StarIcon, CloudUpload as CloudUploadIcon,
  PictureAsPdf as PictureAsPdfIcon, InsertDriveFile as InsertDriveFileIcon,
  CloudDownload as CloudDownloadIcon
} from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import ImageIcon from '@mui/icons-material/Image';
import PdfIcon from '@mui/icons-material/PictureAsPdf';
import FileIcon from '@mui/icons-material/Description';
import moment from 'moment';
import axios from 'axios';
import { axiosInstance, localAxios, localAxiosGet, localAxiosFileUpload } from '../Axios/axios';
import { Loader } from './loade';


// Placeholder for StripedTableRow component (replace with your actual component if needed)
const StripedTableRow = ({ children, ...props }) => (
  <TableRow {...props} sx={{ '&:nth-of-type(odd)': { backgroundColor: '#f9f9f9' } }}>
    {children}
  </TableRow>
);

const capitalizeFirstChar = (str) => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
};

const statusColors = {
  'Pending': 'error',               
  'In Progress': 'primary',         
  'Completed': 'success',    
  'Submitted For Review': 'warning' 
};

const statusTextColors = {
  'Pending': '#fff',              
  'In Progress': '#fff',         
  'Completed': '#fff',             
  'Submitted For Review': '#000'   
};


const priorityColors = {
  'High': 'error',
  'Medium': 'warning',
  'Low': 'info',
};

const stripedRowColors = {
  even: '#f8fafc',
  odd: '#ffffff',
};

const GoalDetails = ({ selectedGoal, isOpen, onClose, isManager, handleEditGoalDetails, handleSubGoalDetails }) => {
  const [value, setValue] = useState(0);
  const [statusAnchorEl, setStatusAnchorEl] = useState(null);
  const [priorityAnchorEl, setPriorityAnchorEl] = useState(null);
  const [updatedGoalDetails, setUpdatedGoalDetails] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [showFeedbackInput, setShowFeedbackInput] = useState(false);
  const [feedbackText, setFeedbackText] = useState('');
  const [isVisibleToEmployee, setIsVisibleToEmployee] = useState(false);
  const [goalDetails, setGoalDetails] = useState(null);
  const [addComment, setAddComment] = useState('');
  const [allComments, setAllComments] = useState([])
  const [commentsLength, setCommentsLength] = useState(null)
  const [attachments, setAttachments] = useState([]);
  const [openPreview, setOpenPreview] = useState(false);
  const [previewFile, setPreviewFile] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const fileInputRef = useRef(null);
  const [saveStatus, setSaveStatus] = useState(null); // 'success', 'error', or null
  const [saveMessage, setSaveMessage] = useState('');



  useEffect(() => {
    fetchGoalDetails();
    fetchAllComments();
  }, [selectedGoal]);

  const fetchGoalDetails = async () => {
    if (!selectedGoal) return;

    setIsLoading(true);
    try {
      const accessToken = localStorage.getItem('accessToken');
      const response = await axiosInstance(
        localAxiosGet(`/empGoal/get_EmpGoal_by_id?id=${selectedGoal}`, accessToken)
      );

      if (response.data.status === 'SUCCESS') {
        setGoalDetails(response.data.result);
        setUpdatedGoalDetails(response.data.result);
      } else {
        console.error('Failed to fetch goal details');
      }
    } catch (error) {
      console.error('Error in fetching goal details', error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchAllComments = async () => {
    try {
      const response = await axiosInstance(localAxiosGet(`/empGoal/get_goal_comments_by_id?goal_id=${selectedGoal}`));
      // const response = await axios(localAxiosGet(`/empGoal/get_goal_comments_by_id?goal_id=1`));
      if (response.data.status === 'SUCCESS') {
        setAllComments(response.data.result.data || []);
        setCommentsLength(response.data.result.totalComments)
      }
    } catch (error) {
      console.error('Error in fetching comments', error);
      setAllComments([]);
      setCommentsLength('')
    }
  };

 // Fix the currentGoalDetails mapping
const currentGoalDetails = goalDetails && {
  id: goalDetails.id,
  emp_id: goalDetails.emp_id,
  goal_id: goalDetails.id,
  title: goalDetails.title,
  goal_title: goalDetails.title,
  goal_type: goalDetails.goal_type,
  project_name: goalDetails.project_name,
  task_name: goalDetails.task_name,
  description: goalDetails.Description,
  Description: goalDetails.Description,
  start_date: goalDetails.start_date,
  due_date: goalDetails.end_date,
  end_date: goalDetails.end_date,
  Attachments: goalDetails.Attachments,
  status: goalDetails.status,
  Ratings: goalDetails.Ratings,
  rating: goalDetails.Ratings,
  // Fix this line - pass the entire array, not just the first category
  catagore_json: goalDetails.catagore_json, // Changed this line
  manager_first_name: "Manager",
  manager_last_name: "Name",
  reported_manager_id: goalDetails.report_manager_id,
  hr_id: goalDetails.hr_id,
  hr_name: goalDetails.hr_name,
  reporting_manager_name: goalDetails.report_manager_name,
  employee_name: goalDetails.employee_name,
  goal_type_name: goalDetails.goal_detail,
  submit_for_review: goalDetails.submit_for_review,
  feedback: goalDetails.feedback,
  goal_period: goalDetails.goal_period
}

  const handleAddComment = (e) => {
    setAddComment(e.target.value);
  }

  const handleSendForReviewButton = async () => {
    setIsLoading(true);
    setSaveStatus(null);

    try {
      // If manager is updating status, rating, or feedback
      if (isManager && (
        updatedGoalDetails.status !== currentGoalDetails?.status ||
        updatedGoalDetails.rating !== currentGoalDetails?.rating ||
        feedbackText.trim()
      )) {
        // Prepare manager update payload
        const managerUpdatePayload = {
          id: selectedGoal,
          status: updatedGoalDetails.status,
          Ratings: updatedGoalDetails.rating,
          feedback: feedbackText.trim(),
        };

        const managerResponse = await axiosInstance(localAxios('/empGoal/update_EmpGoal', managerUpdatePayload));

        if (managerResponse.data.status === 'SUCCESS') {
          setSaveStatus('success');
          setSaveMessage('Goal updated successfully!');

          // Update local state
          setGoalDetails(prev => ({
            ...prev,
            status: updatedGoalDetails.status,
            Ratings: updatedGoalDetails.rating,
            feedback: feedbackText.trim()
          }));

          // Reset feedback fields
          setFeedbackText('');
          setShowFeedbackInput(false);
        } else {
          setSaveStatus('error');
          setSaveMessage('Failed to update goal details');
        }

        // Refresh goal details
        await fetchGoalDetails();
        return;
      }

      // Original employee send for review logic
      if (!addComment.trim() && attachments.length === 0) {
        setIsLoading(false);
        return;
      }

      // 1. Send the comment only if one is present
      if (addComment.trim()) {
        const payload = {
          emp_id: currentGoalDetails.emp_id,
          goal_id: selectedGoal,
          comment: addComment,
          report_mang_id: currentGoalDetails?.goal_type === 'Personal Goal'
            ? currentGoalDetails?.hr_id
            : currentGoalDetails?.report_manager_id
        };

        const response = await axiosInstance(localAxios('/empGoal/add_goal_comment', payload));

        if (response.data.status === 'SUCCESS') {
          fetchAllComments();
          setAddComment('');
        }
      }

      // 2. Handle attachments only if they exist
      if (attachments.length > 0) {
        const formData = new FormData();
        attachments.forEach((attachment) => {
          formData.append('Attachments', attachment.file);
        });
        formData.append('id', selectedGoal);
      
        const uploadResponse = await axiosInstance(localAxiosFileUpload(
          '/empGoal/update_EmpGoal',
          formData,
        ));
      
        if (uploadResponse.data?.message?.attachments) {
          setUploadedFiles(prev => [...prev, ...uploadResponse.data.message.attachments]);
          setAttachments([]); // This line already exists - good!
        } else if (uploadResponse.data?.status === 'success') {
          // Add this condition to handle successful uploads without specific attachment response
          setAttachments([]); // Clear attachments on successful upload
        }
      }

      // 3. Refresh goal details
      fetchAllComments()
      await fetchGoalDetails();

      setSaveStatus('success');
      setSaveMessage('Sent for review successfully!');
      setAttachments([]);

    } catch (error) {
      console.error('Error in sending for review', error);
      setAddComment('');
      setSaveStatus('error');
      setSaveMessage('Failed to send for review');
    } finally {
      setIsLoading(false);
    }
  };


  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const openStatusMenu = (event) => {
    setStatusAnchorEl(event.currentTarget);
  };

  const closeStatusMenu = (status) => {
    setStatusAnchorEl(null);
    console.log('Status updated to:', status);
  };

  const openPriorityMenu = (event) => {
    setPriorityAnchorEl(event.currentTarget);
  };

  const closePriorityMenu = (priority) => {
    setPriorityAnchorEl(null);
    console.log('Priority updated to:', priority);
  };


  // Add snackbar close handler
  const handleCloseSnackbar = () => {
    setSaveStatus(null);
    setSaveMessage('');
  };

  const handleAddFeedback = () => {
    // This is where you'll implement the logic to:
    // 1. Access the current values of feedbackText and isVisibleToEmployee.
    console.log("Feedback:", feedbackText);
    console.log("Visible to Employee:", isVisibleToEmployee);

    // 2. Update your goalDetails state or send the feedback data to your backend.
    //    (You'll likely need to work with props or other state management solutions here)
    //    Example:
    //    const newFeedback = { text: feedbackText, visible: isVisibleToEmployee };
    //    // Update your goalDetails state or call a function to save to the backend

    // 3. Reset the input fields.
    setFeedbackText('');
    setIsVisibleToEmployee(false);
    // 4. Hide the input area after adding feedback.
    setShowFeedbackInput(false);
  };

  const toggleFeedbackInput = () => {
    setShowFeedbackInput(!showFeedbackInput);
    // Optionally clear the text when hiding the input
    if (showFeedbackInput) {
      setFeedbackText('');
      setIsVisibleToEmployee(false);
    }
  };

  // Handle file upload
  const handleFileUpload = (event) => {
    const files = Array.from(event.target.files);

    const newAttachments = files.map(file => ({
      id: `file-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
      file: file,
      name: file.name,
      type: file.type,
      url: URL.createObjectURL(file)
    }));

    setAttachments([...attachments, ...newAttachments]);
    // Reset file input
    event.target.value = null;
  };

  // Handle opening file preview
  const handleOpenPreview = (attachment) => {
    setPreviewFile(attachment);
    setOpenPreview(true);
  };

  // Handle closing file preview
  const handleClosePreview = () => {
    setOpenPreview(false);
    setPreviewFile(null);
  };

  // Handle deleting an attachment
  const handleDeleteAttachment = (id) => {
    const updatedAttachments = attachments.filter(attachment => attachment.id !== id);
    setAttachments(updatedAttachments);
  };

  // Render appropriate icon based on file type
  const renderFileIcon = (fileType) => {
    if (fileType.startsWith('image/')) {
      return <ImageIcon />;
    } else if (fileType === 'application/pdf') {
      return <PdfIcon />;
    } else {
      return <FileIcon />;
    }
  };

  const UploadedFilesList = () => {
    const [openPreview, setOpenPreview] = useState(false);
    const [previewFile, setPreviewFile] = useState(null);

    // Parse the attachments data
    const parseAttachments = () => {
      try {
        if (!currentGoalDetails?.Attachments) return [];

        const attachmentsData = currentGoalDetails.Attachments;

        // Handle case where Attachments is a direct URL string
        if (typeof attachmentsData === 'string') {
          // Check if it's a URL (starts with http/https)
          if (attachmentsData.startsWith('http://') || attachmentsData.startsWith('https://')) {
            // Extract filename from URL or use a default name
            const urlParts = attachmentsData.split('/');
            const fileName = urlParts[urlParts.length - 1] || 'uploaded_file';

            return [{
              url: attachmentsData,
              name: fileName,
              type: fileName.match(/\.(jpeg|jpg|png|gif)$/i) ? 'image' :
                fileName.endsWith('.pdf') ? 'pdf' : 'file'
            }];
          }

          // Try to parse as JSON if it's not a URL
          try {
            const parsedData = JSON.parse(attachmentsData);

            // Handle array of attachments
            if (Array.isArray(parsedData)) {
              return parsedData.map(attachment => ({
                url: attachment.url || attachment.file_url,
                name: attachment.name || attachment.file_name || 'Unknown file',
                type: (attachment.name || attachment.file_name)?.match(/\.(jpeg|jpg|png|gif)$/i) ? 'image' :
                  (attachment.name || attachment.file_name)?.endsWith('.pdf') ? 'pdf' : 'file'
              }));
            }
            // Handle single attachment object
            else if (parsedData && (parsedData.url || parsedData.file_url)) {
              return [{
                url: parsedData.url || parsedData.file_url,
                name: parsedData.name || parsedData.file_name || 'Unknown file',
                type: (parsedData.name || parsedData.file_name)?.match(/\.(jpeg|jpg|png|gif)$/i) ? 'image' :
                  (parsedData.name || parsedData.file_name)?.endsWith('.pdf') ? 'pdf' : 'file'
              }];
            }
          } catch (jsonError) {
            console.log('Attachments is not valid JSON, treating as string:', attachmentsData);
            // If it's not JSON and not a URL, return empty
            return [];
          }
        }
        // Handle case where Attachments is already an object/array
        else if (typeof attachmentsData === 'object') {
          // Handle array of attachments
          if (Array.isArray(attachmentsData)) {
            return attachmentsData.map(attachment => ({
              url: attachment.url || attachment.file_url,
              name: attachment.name || attachment.file_name || 'Unknown file',
              type: (attachment.name || attachment.file_name)?.match(/\.(jpeg|jpg|png|gif)$/i) ? 'image' :
                (attachment.name || attachment.file_name)?.endsWith('.pdf') ? 'pdf' : 'file'
            }));
          }
          // Handle single attachment object
          else if (attachmentsData.url || attachmentsData.file_url) {
            return [{
              url: attachmentsData.url || attachmentsData.file_url,
              name: attachmentsData.name || attachmentsData.file_name || 'Unknown file',
              type: (attachmentsData.name || attachmentsData.file_name)?.match(/\.(jpeg|jpg|png|gif)$/i) ? 'image' :
                (attachmentsData.name || attachmentsData.file_name)?.endsWith('.pdf') ? 'pdf' : 'file'
            }];
          }
        }

        return [];
      } catch (error) {
        console.error('Error parsing attachments:', error);
        console.log('Raw attachments data:', currentGoalDetails?.Attachments);
        return [];
      }
    };

    const allFiles = parseAttachments();

    if (allFiles.length === 0) return null;

    const isImageFile = (filename) => {
      return filename?.match(/\.(jpeg|jpg|png|gif)$/i);
    };

    const isPdfFile = (filename) => {
      return filename?.endsWith('.pdf');
    };

    const handleOpenPreview = (file) => {
      if (!file || !file.name) return;

      setPreviewFile(file);

      // For images, open in dialog
      if (isImageFile(file.name)) {
        setOpenPreview(true);
      }
      // For PDFs and other files, open in new tab
      else if (file.url) {
        window.open(file.url, '_blank', 'noopener,noreferrer');
      }
    };

    const handleDownload = async (file) => {
      try {
        if (!file || !file.url) return;

        const link = document.createElement('a');
        link.href = file.url;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.download = file.name || 'download';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error('Download failed:', error);
        if (file.url) {
          window.open(file.url, '_blank');
        }
      }
    };

    return (
      <>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            backgroundColor: 'rgba(100, 181, 246, 0.1)',
            padding: '8px',
            mt: 2,
            borderRadius: '4px 4px 0 0',
          }}
        >
          <CloudUploadIcon color="primary" />
          <Typography variant="subtitle2" color="primary" fontWeight={600}>
            Uploaded files ({allFiles.length})
          </Typography>
        </Box>

        <TableContainer component={Paper} elevation={2}>
          <Table size="small">
            <TableBody>
              {allFiles.map((file, index) => (
                <TableRow key={`${file.name}-${index}`}>
                  <TableCell sx={{ width: 40 }}>
                    {isImageFile(file.name) ? (
                      <ImageIcon color="primary" />
                    ) : isPdfFile(file.name) ? (
                      <PictureAsPdfIcon color="error" />
                    ) : (
                      <InsertDriveFileIcon color="action" />
                    )}
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2" noWrap sx={{ maxWidth: 300 }}>
                      {file.name || 'Unknown file'}
                    </Typography>
                  </TableCell>
                  <TableCell align="right" sx={{ width: 120 }}>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                      <Tooltip title={isImageFile(file.name) ? "Preview" : "View"}>
                        <IconButton
                          size="small"
                          onClick={() => handleOpenPreview(file)}
                          color="primary"
                          disabled={!file.url}
                        >
                          <VisibilityIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Download">
                        <IconButton
                          size="small"
                          onClick={() => handleDownload(file)}
                          color="primary"
                          disabled={!file.url}
                        >
                          <CloudDownloadIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Image Preview Dialog */}
        {openPreview && previewFile && previewFile.name && isImageFile(previewFile.name) && (
          <Dialog
            open={openPreview}
            onClose={() => setOpenPreview(false)}
            maxWidth="md"
            fullWidth
          >
            <DialogTitle>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h6">{previewFile.name}</Typography>
                <IconButton onClick={() => setOpenPreview(false)}>
                  <CloseIcon />
                </IconButton>
              </Box>
            </DialogTitle>
            <DialogContent sx={{ textAlign: 'center', p: 2 }}>
              {previewFile.url ? (
                <img
                  src={previewFile.url}
                  alt={previewFile.name}
                  style={{
                    maxWidth: '100%',
                    maxHeight: '70vh',
                    objectFit: 'contain'
                  }}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBmaWxsPSIjRkZGRkZGIi8+CjxwYXRoIGQ9Ik0yMSAxOUgyM1Y1SDFWMTlIM1Y3SDIxVjE5Wk0xOCAxM0gxNVYxMEgxM1YxM0gxMFYxNUgxM1YxOEgxNVYxNUgxOFYxM1pNOSA5SDNWNUg5VjlaIiBmaWxsPSIjOTk5OTk5Ii8+Cjwvc3ZnPg==';
                  }}
                />
              ) : (
                <Typography>Image not available</Typography>
              )}
            </DialogContent>
            <DialogActions>
              {previewFile.url && (
                <Button
                  startIcon={<CloudDownloadIcon />}
                  onClick={() => handleDownload(previewFile)}
                  variant='contained'
                >
                  Download
                </Button>
              )}
              <Button variant='outlined' onClick={() => setOpenPreview(false)}>Close</Button>
            </DialogActions>
          </Dialog>
        )}
      </>
    );
  };

  return (
    <>
      <Modal
        open={isOpen}
        onClose={onClose}

      >
        <Box
          sx={{
            maxWidth: 'lg',
            maxHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            margin: 'auto',
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            backdropFilter: 'blur(10px)',
            borderRadius: 3,
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
            zIndex: "100"
          }}
        >

          {/* Scrollable Content */}
          <Box sx={{ flex: 1, overflowY: 'auto', p: 2 }}>
            <Box sx={{ display: 'flex', bgcolor: '#f0f4f8', borderRadius: '12px' }}>
              {isLoading && <Loader />}
              <Box sx={{ flexGrow: 1, overflow: 'auto', borderRadius: '12px', p: 2 }}>
                <Box sx={{
                  display: 'flex',
                  alignItems: 'center',
                  borderRadius: '12px',
                  bgcolor: 'white'
                }}>
                  <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
                    p: 2,
                    borderRadius: '4px',
                    color: 'white',
                    justifyContent: 'space-between',
                    width: '100%'
                  }}>
                    <Typography variant="h5" component="span" sx={{ fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
                      <TaskAlt />
                      My Goal Details
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'row', mt: 2, gap: 2 }}>
                  <Box sx={{ p: 3, bgcolor: '#ffffff', flexGrow: 1, display: 'flex' }}>
                    <Box sx={{ flexGrow: 1 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          <Typography
                            variant="h6"
                            color="primary"
                            sx={{ fontWeight: 'bold', color: '#2e86de' }}
                          >
                            #{currentGoalDetails?.goal_id || 'N/A'}
                          </Typography>
                          <Typography variant="h6" sx={{ ml: 1 }}>
                            {currentGoalDetails?.goal_title || 'Goal Title'}
                          </Typography>
                        </Box>

                        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                          {currentGoalDetails?.submit_for_review && !isManager && (
                            <Chip
                              label={"Sent for Review"}
                              size="small"
                              variant="contained"
                              sx={{ backgroundColor: '#FFBF00', color: 'white' }}
                            />
                          )}
                          {!isManager && (
                            <Box>
                              <IconButton
                                aria-label="edit"
                                size="small"
                                sx={{ color: 'orange' }}
                                onClick={() => handleEditGoalDetails(currentGoalDetails)}
                              >
                                <EditIcon />
                              </IconButton>
                              <IconButton aria-label="delete" size="small" color="error">
                                <DeleteIcon />
                              </IconButton>
                            </Box>
                          )}
                        </Box>
                      </Box>
                      <Box mt={1}>
                        <Chip
                          label={currentGoalDetails?.goal_type || 'Personal'}
                          size="small"
                          color={currentGoalDetails?.goal_type === 'Personal' ? 'primary' : 'secondary'}
                        />
                      </Box>

                      <Box mt={2} bgcolor="#f8fafc" p={2} borderRadius={1}>
                        <Grid container spacing={2}>
                        {(currentGoalDetails?.goal_type === 'Business Goal' || currentGoalDetails?.goal_type === 'Business') && (
                            <>
                              {currentGoalDetails?.project_name && (
                                <Grid item xs={12} md={6}>
                                  <Box sx={{ display: 'flex',flexDirection: { sm: 'column', md: 'row' }, gap: 0.5 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                      <Business sx={{ color: '#1976d2' }} />
                                      <Typography variant="subtitle2" color="textSecondary">
                                        Project Name
                                      </Typography>
                                    </Box>
                                    <Chip
                                      label={currentGoalDetails.project_name}
                                      size="small"
                                      sx={{ alignSelf: 'flex-start' }}
                                    />
                                  </Box>
                                </Grid>
                              )}
                              {currentGoalDetails?.task_name && (
                                <Grid item xs={12} md={6}>
                                  <Box sx={{ display: 'flex',flexDirection: { xs: 'column', lg: 'row' }, gap: 0.5 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                      <Typography variant="subtitle2" color="textSecondary">
                                        Task Name
                                      </Typography>
                                    </Box>
                                    <Chip
                                      label={currentGoalDetails.task_name}
                                      size="small"
                                      sx={{ alignSelf: 'flex-start' }}
                                    />
                                  </Box>
                                </Grid>
                              )}
                            </>
                          )}

                          {(() => {
                            let createdByLabel = currentGoalDetails?.employee_name || '';
                            if (currentGoalDetails?.goal_type_name === 'Predefined Business Goal') {
                              createdByLabel = currentGoalDetails?.reporting_manager_name || '';
                            } else if (currentGoalDetails?.goal_type === 'Personal Goal') {
                              createdByLabel = currentGoalDetails?.hr_name || '';
                            }

                            return createdByLabel ? (
                              <Grid item xs={12} md={6}>
                                <Box sx={{ display: 'flex', flexDirection: { xs: 'column', lg: 'row' }, gap: 0.5 }}>
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <PersonIcon sx={{ color: '#4caf50' }} />
                                    <Typography variant="subtitle2" color="textSecondary">
                                      Created By
                                    </Typography>
                                  </Box>
                                  <Chip
                                    label={createdByLabel}
                                    size="small"
                                    sx={{ alignSelf: 'flex-start' }}
                                  />
                                </Box>
                              </Grid>
                            ) : null;
                          })()}

                          {currentGoalDetails?.goal_type_name && (
                            <Grid item xs={12} md={6}>
                              <Box sx={{ display: 'flex', flexDirection: { xs: 'column', lg: 'row' }, gap: 0.5 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                  {currentGoalDetails?.development_type ? <Code sx={{ color: '#f57c00' }} /> : <AssignmentInd sx={{ color: '#2e7d32' }} />}
                                  <Typography variant="subtitle2" color="textSecondary">
                                    Goal Type
                                  </Typography>
                                </Box>
                                <Chip
                                  label={currentGoalDetails.goal_type_name}
                                  size="small"
                                  sx={{ alignSelf: 'flex-start' }}
                                />
                              </Box>
                            </Grid>
                          )}

                          {currentGoalDetails?.goal_category && (
                            <Grid item xs={12} md={6}>
                              <Box sx={{ display: 'flex', flexDirection: { xs: 'column', lg: 'row' }, gap: 0.5 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                  {currentGoalDetails?.development_type ? <Code sx={{ color: '#f57c00' }} /> : <AssignmentInd sx={{ color: '#2e7d32' }} />}
                                  <Typography variant="subtitle2" color="textSecondary">
                                    Goal category
                                  </Typography>
                                </Box>
                                <Chip
                                  label={currentGoalDetails.goal_category}
                                  size="small"
                                  color="default"
                                  sx={{ alignSelf: 'flex-start' }}
                                />
                              </Box>
                            </Grid>
                          )}

                          {(currentGoalDetails?.start_date || currentGoalDetails?.due_date || currentGoalDetails?.goal_period) && (
                            <Grid item xs={12} md={6}>
                              <Box sx={{ display: 'flex', flexDirection: { xs: 'column', lg: 'row' }, gap: 0.5 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                  <TimelineIcon sx={{ color: '#9c27b0' }} />
                                  <Typography variant="subtitle2" color="textSecondary">
                                    Timeline
                                  </Typography>
                                </Box>
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                  {(currentGoalDetails?.start_date || currentGoalDetails?.due_date) ? (
                                    <>
                                      {currentGoalDetails?.start_date && (
                                        <Chip
                                          label={moment(currentGoalDetails.start_date).format('DD-MM-YYYY')}
                                          size="small"
                                        />
                                      )}
                                      {currentGoalDetails?.due_date && (
                                        <Chip
                                          label={moment(currentGoalDetails.due_date).format('DD-MM-YYYY')}
                                          size="small"
                                        />
                                      )}
                                    </>
                                  ) : (
                                    currentGoalDetails?.goal_period && (
                                      <Chip
                                        label={currentGoalDetails.goal_period}
                                        size="small"
                                      />
                                    )
                                  )}
                                </Box>
                              </Box>
                            </Grid>
                          )}

                          {currentGoalDetails?.attachments && currentGoalDetails.attachments.length > 0 && (
                            <Grid item xs={12}>
                              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                  <AttachFileIcon sx={{ color: '#757575' }} />
                                  <Typography variant="subtitle2" color="textSecondary">
                                    Attachments ({currentGoalDetails.attachments.length})
                                  </Typography>
                                </Box>
                              </Box>
                            </Grid>
                          )}
                        </Grid>
                      </Box>
                      <Box
                        sx={{
                          border: '1px solid #ccc',
                          borderRadius: '4px',
                          marginBottom: '16px',
                          mt: 2,
                          bgcolor: '#f8fafc'
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                            backgroundColor: 'rgba(100, 181, 246, 0.1)',
                            padding: '8px',
                            borderBottom: '1px solid #ccc',
                          }}
                        >
                          <DescriptionIcon color="primary" />
                          <Typography variant="subtitle2" color="primary" fontWeight={600}>
                            Description
                          </Typography>
                        </Box>
                        <Box sx={{ padding: '16px' }}>
                          <Typography variant="body2" color="text.secondary">
                            {capitalizeFirstChar(currentGoalDetails?.description) || 'No Objective Added'}
                          </Typography>
                        </Box>
                      </Box>


                      <Box
                        sx={{
                          borderRadius: '4px',
                          marginBottom: '16px',
                          mt: 2,
                          bgcolor: '#f8fafc'
                        }}
                      >

                        <UploadedFilesList />
                      </Box>

                      {/* Feedback Section - Add this after the UploadedFilesList component */}
                      {currentGoalDetails?.feedback && (
                        <Box
                          sx={{
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            marginBottom: '16px',
                            mt: 2,
                            bgcolor: '#f8fafc'
                          }}
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 1,
                              backgroundColor: 'rgba(76, 175, 80, 0.1)',
                              padding: '8px',
                              borderBottom: '1px solid #ccc',
                            }}
                          >
                            <EditIcon color="success" />
                            <Typography variant="subtitle2" color="success.main" fontWeight={600}>
                              Feedback
                            </Typography>
                          </Box>
                          <Box sx={{ padding: '16px' }}>
                            <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'pre-wrap' }}>
                              {capitalizeFirstChar(currentGoalDetails.feedback) || 'No feedback available'}
                            </Typography>
                          </Box>
                        </Box>
                      )}

{currentGoalDetails?.catagore_json && currentGoalDetails.catagore_json.length > 0 && (
  <Box
    sx={{
      border: '1px solid #ccc',
      borderRadius: '4px',
      marginBottom: '16px',
      mt: 2,
      bgcolor: '#f8fafc'
    }}
  >
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        backgroundColor: 'rgba(156, 39, 176, 0.1)',
        padding: '8px',
        borderBottom: '1px solid #ccc',
      }}
    >
      <PlaylistAddCheckIcon color="secondary" />
      <Typography variant="subtitle2" color="secondary.main" fontWeight={600}>
        Categories ({currentGoalDetails.catagore_json.length})
      </Typography>
    </Box>
    {/* <Box sx={{ padding: '16px' }}>
      {currentGoalDetails.catagore_json.map((category, index) => (
        <Box key={index} sx={{ mb: 2, p: 1.5, backgroundColor: 'white', borderRadius: '4px', border: '1px solid #e0e0e0' }}>
          <Typography variant="subtitle2" color="primary" fontWeight={600}>
            {category.category || 'Uncategorized'}
          </Typography>
          {category.description && (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              {capitalizeFirstChar(category.description)}
            </Typography>
          )}
        </Box>
      ))}
    </Box> */}
  </Box>
)}

                      <Box sx={{ mt: 4, mb: 2 }}>
                        <Tabs value={value} onChange={handleChange}>
                          <Tab label={`${commentsLength || 0} Comments`} />
                          {/* <Tab label="Activities" /> */}
                        </Tabs>
                        <Box sx={{ mt: 2 }}>
                          {value === 0 ? (
                            <Box >
                              <TextField
                                fullWidth
                                multiline
                                minRows={3}
                                maxRows={6}
                                placeholder="Type a new comment here"
                                variant="outlined"
                                size="medium"
                                value={addComment || ''}
                                onChange={handleAddComment}
                                sx={{
                                  '& .MuiOutlinedInput-root': {
                                    alignItems: 'flex-start',
                                  }
                                }}
                              />

                              <Box sx={{ width: '100%', overflow: 'auto', mt: 2 }}>
                                {allComments && allComments.length > 0 ? (
                                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                    {allComments.map((comment) => (
                                      <Paper key={comment.id} sx={{ p: 2, display: 'flex', gap: 2, alignItems: 'flex-start' }}>
                                        {/* Avatar Column */}
                                        <Box sx={{ minWidth: 50, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                                          <Avatar sx={{
                                            width: 36,
                                            height: 36,
                                            fontSize: '1rem',
                                            backgroundColor: comment.user_type === 'Manager'
                                              ? (theme) => theme.palette.primary.main
                                              : (theme) => theme.palette.secondary.main,
                                            color: comment.user_type === 'Manager'
                                              ? (theme) => theme.palette.primary.contrastText
                                              : (theme) => theme.palette.secondary.contrastText,
                                          }}>
                                            {comment.user_type === 'Manager' ? 'M' : 'E'}
                                          </Avatar>
                                        </Box>

                                        {/* Content Column */}
                                        <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                                          {/* Header with name and timestamp */}
                                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1, flexWrap: 'wrap' }}>
                                            <Typography variant="subtitle2" fontWeight="bold">
                                              {comment.user_type === 'Employee'
                                                ? `${capitalizeFirstChar(comment.employee?.first_name)} ${capitalizeFirstChar(comment.employee?.last_name)}`
                                                : `${capitalizeFirstChar(comment.reportManager?.first_name)} ${capitalizeFirstChar(comment.reportManager?.last_name)}`
                                              }
                                            </Typography>
                                            <Typography variant="caption" color="text.secondary">
                                              {moment(comment.createdAt).format('YYYY-MM-DD HH:mm')}
                                            </Typography>
                                          </Box>

                                          {/* Comment text */}
                                          <Typography variant="body2" sx={{
                                            wordBreak: 'break-word',
                                            lineHeight: 1.5,
                                            whiteSpace: 'pre-wrap'
                                          }}>
                                            {capitalizeFirstChar(comment.comment)}
                                          </Typography>
                                        </Box>
                                      </Paper>
                                    ))}
                                  </Box>
                                ) : (
                                  <Typography variant="body2" color="text.secondary" align="center" mt={2}>
                                    No comments yet.
                                  </Typography>
                                )}
                              </Box>
                            </Box>
                          ) : (
                            <Box sx={{ mt: 1 }}>
                              {/* Activities content */}
                            </Box>
                          )}
                        </Box>
                      </Box>
                    </Box>
                  </Box>

                  {/* Right Sidebar */}
                  <Box sx={{ ml: 2, width: 300 }}>
                    <Box >
                      <Paper sx={{ p: 3, mb: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', gap: 2, mb: 2 }}>
                          <Chip
                            label={updatedGoalDetails?.status || currentGoalDetails?.status || 'Not Set'}
                            color={statusColors[updatedGoalDetails?.status || currentGoalDetails?.status] || 'default'}
                            size="medium"
                            variant="contained"
                            sx={{ padding: '4px', fontWeight: 'bold' }}
                            onClick={openStatusMenu}
                          >
                            {updatedGoalDetails?.status || currentGoalDetails?.status || 'Not Set'}
                          </Chip>
                          {isManager && (
                            <Menu
                              anchorEl={statusAnchorEl}
                              open={Boolean(statusAnchorEl)}
                              onClose={() => setStatusAnchorEl(null)}
                            >
                              <MenuItem onClick={() => { closeStatusMenu('Pending'); setUpdatedGoalDetails(prev => ({ ...prev, status: 'Pending' })); }}>Pending</MenuItem>
                              <MenuItem onClick={() => { closeStatusMenu('In Progress'); setUpdatedGoalDetails(prev => ({ ...prev, status: 'In Progress' })); }}>In Progress</MenuItem>
                              <MenuItem onClick={() => { closeStatusMenu('Completed'); setUpdatedGoalDetails(prev => ({ ...prev, status: 'Completed' })); }}>Completed</MenuItem>
                              <MenuItem onClick={() => { closeStatusMenu('Submitted For Review'); setUpdatedGoalDetails(prev => ({ ...prev, status: 'Submitted For Review' })); }}>Submitted For Review</MenuItem>
                              <MenuItem onClick={() => { closeStatusMenu('Accepted'); setUpdatedGoalDetails(prev => ({ ...prev, status: 'Accepted' })); }}>Accepted</MenuItem>
                              <MenuItem onClick={() => { closeStatusMenu('Rejected'); setUpdatedGoalDetails(prev => ({ ...prev, status: 'Rejected' })); }}>Rejected</MenuItem>
                            </Menu>
                          )}
                        </Box>
                        {!isManager && (
                          <Divider sx={{ mb: 2 }} />
                        )}

                        {/* Attachments section */}
                        {!isManager && (
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'column', mb: 2, gap: 2 }}>
                            <Typography variant="subtitle1" fontWeight="bold">
                              Attachments
                            </Typography>
                            <Button
                              variant="outlined"
                              startIcon={<AttachFileIcon />}
                              onClick={() => fileInputRef.current.click()}
                              size="small"
                              sx={{ width: '200px' }}
                            >
                              Add Attachments
                            </Button>
                            <input
                              ref={fileInputRef}
                              type="file"
                              multiple
                              onChange={handleFileUpload}
                              style={{ display: 'none' }}
                            />
                          </Box>
                        )}

                        {attachments.length > 0 && (
                          <Grid container spacing={1} sx={{ mb: 2 }}>
                            {attachments.map((attachment) => (
                              <Grid item key={attachment.id}>
                                <Paper
                                  elevation={1}
                                  sx={{
                                    p: 1,
                                    display: 'flex',
                                    alignItems: 'center',
                                    maxWidth: 150,
                                    position: 'relative',
                                    cursor: 'pointer',
                                    '&:hover': {
                                      bgcolor: 'action.hover',
                                    }
                                  }}
                                  onClick={() => handleOpenPreview(attachment)}
                                >
                                  <Box sx={{ mr: 1 }}>
                                    {renderFileIcon(attachment.type)}
                                  </Box>
                                  <Typography variant="caption" noWrap>
                                    {attachment.name}
                                  </Typography>
                                  <IconButton
                                    size="small"
                                    sx={{
                                      position: 'absolute',
                                      top: -8,
                                      right: -8,
                                      bgcolor: 'background.paper',
                                      boxShadow: 1,
                                      '&:hover': {
                                        bgcolor: 'error.light',
                                        color: 'common.white'
                                      },
                                      width: 20,
                                      height: 20
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleDeleteAttachment(attachment.id);
                                    }}
                                  >
                                    <CloseIcon fontSize="small" />
                                  </IconButton>
                                </Paper>
                              </Grid>
                            ))}
                          </Grid>
                        )}

                        {/* Preview Dialog */}
                        <Dialog
                          open={openPreview}
                          onClose={handleClosePreview}
                          maxWidth="md"
                          fullWidth
                        >
                          <DialogContent sx={{ position: 'relative', p: 1 }}>
                            <IconButton
                              onClick={handleClosePreview}
                              sx={{
                                position: 'absolute',
                                right: 8,
                                top: 8,
                                color: 'grey.500',
                                bgcolor: 'background.paper',
                                zIndex: 1,
                                boxShadow: 1
                              }}
                            >
                              <CloseIcon />
                            </IconButton>

                            {previewFile && previewFile.type.startsWith('image/') ? (
                              <Box sx={{ display: 'flex', justifyContent: 'center', pt: 4 }}>
                                <img
                                  src={previewFile.url}
                                  alt={previewFile.name}
                                  style={{ maxWidth: '100%', maxHeight: '70vh' }}
                                />
                              </Box>
                            ) : (
                              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', pt: 4 }}>
                                <Box sx={{ fontSize: 60, mb: 2 }}>
                                  {previewFile && renderFileIcon(previewFile.type)}
                                </Box>
                                <Typography variant="h6">
                                  {previewFile && previewFile.name}
                                </Typography>
                                <Button
                                  variant="contained"
                                  sx={{ mt: 2 }}
                                  href={previewFile && previewFile.url}
                                  target="_blank"
                                  download={previewFile && previewFile.name}
                                >
                                  Download
                                </Button>
                              </Box>
                            )}
                          </DialogContent>
                        </Dialog>
                        <Divider sx={{ mb: 2 }} />

                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 2 }}>
                          <Typography variant="subtitle1" fontWeight="bold">
                            Reported To
                          </Typography>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Avatar sx={{ width: 30, height: 30, bgcolor: (theme) => theme.palette.primary.main }}>
                              {currentGoalDetails?.goal_type === 'Personal Goal'
                                ? currentGoalDetails?.hr_name?.charAt(0)?.toUpperCase() || 'H'
                                : currentGoalDetails?.reporting_manager_name?.charAt(0)?.toUpperCase() || 'M'
                              }
                            </Avatar>
                            <Typography variant="body2">
                              {currentGoalDetails?.goal_type === 'Personal Goal'
                                ? currentGoalDetails?.hr_name || 'HR Manager'
                                : currentGoalDetails?.reporting_manager_name || 'Reporting Manager'
                              }
                            </Typography>
                          </Box>
                        </Box>

                        <Divider sx={{ mb: 2 }} />
                        <Box>
                          <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                            Ratings
                          </Typography>

                          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, justifyContent: 'space-between' }}>
                            {/* Left side: Rating input and / 5 */}
                            {isManager && (
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <TextField
                                  type="number"
                                  variant="outlined"
                                  size="small"
                                  label="Rating"
                                  value={updatedGoalDetails?.rating ?? currentGoalDetails?.rating ?? ''}
                                  onChange={(e) => {
                                    const value = parseFloat(e.target.value);
                                    if (isNaN(value) || value < 0 || value > 5) {
                                      setUpdatedGoalDetails(prev => ({ ...prev, rating: '' }));
                                    } else {
                                      setUpdatedGoalDetails(prev => ({ ...prev, rating: value }));
                                    }
                                  }}
                                  inputProps={{ min: 0, max: 5, step: 1 }}
                                  sx={{ width: 100, mr: 2 }}
                                />
                              </Box>
                            )}
                            {/* Right side: Star icons */}
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                              {[...Array(5)].map((_, index) => {
                                const rating = updatedGoalDetails?.rating ?? currentGoalDetails?.rating ?? 0;
                                const fullStar = index + 1 <= Math.floor(rating);
                                const halfStar = index + 0.5 === rating;

                                return (
                                  <React.Fragment key={index}>
                                    {fullStar ? (
                                      <StarIcon color="warning" />
                                    ) : halfStar ? (
                                      <StarHalfIcon color="warning" />
                                    ) : (
                                      <StarIcon color="action" />
                                    )}
                                  </React.Fragment>
                                );
                              })}
                            </Box>
                          </Box>
                          <Typography variant="caption" color="textSecondary">
                            Give a rating (0-5, increments of 0.5)
                          </Typography>
                        </Box>
                        {isManager && (
                          <Divider sx={{ mb: 2 }} />
                        )}
                        {isManager && (
                          <Box>
                            <Button
                              variant="outlined"
                              startIcon={showFeedbackInput ? <CloseIcon /> : <AddIcon />}
                              onClick={toggleFeedbackInput}
                            >
                              {showFeedbackInput ? 'Cancel Feedback' : 'Add Feedback'}
                            </Button>

                            {showFeedbackInput && (
                              <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 1 }}>
                                <TextField
                                  fullWidth
                                  multiline
                                  rows={10}
                                  placeholder="Enter feedback here"
                                  variant="outlined"
                                  value={feedbackText}
                                  onChange={(e) => setFeedbackText(e.target.value)}
                                />


                              </Box>
                            )}
                          </Box>
                        )}
                      </Paper>
                    </Box>

                  </Box>
                </Box>
              </Box>
            </Box >
          </Box>

          {/* Fixed Footer */}

          <Box sx={{ p: 2, borderTop: '1px solid #e0e0e0', display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
            {isManager ? (
              <Button variant='contained' onClick={handleSendForReviewButton}>Submit</Button>
            ) : (
              <Button variant='contained' onClick={handleSendForReviewButton}>Send For Review</Button>
            )}
            <Button variant="outlined" color="primary" onClick={onClose}>
              CLOSE
            </Button>
          </Box>



        </Box>

      </Modal>
      <Snackbar
        open={saveStatus !== null}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={saveStatus || 'info'}
          sx={{ width: '100%' }}
        >
          {saveMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default GoalDetails;